export default __webpack_public_path__ + "static/media/AAPG-Pivoting-3.b360b123.png";